import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from 'src/app/shared/services/environment-loader.service';
import { PagedResult } from '../models/paging';
import {
  DepartmentGroup,
  CreateDepartmentGroupRequest,
  UpdateDepartmentGroupRequest,
} from 'src/app/features/department/departmentGroup.model';

@Injectable({
  providedIn: 'root',
})
export default class DepartmentGroupService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/DepartmentGroup';
  }

  public getDepartmentGroups(
    organizationId?: number,
    query?: string,
    page?: number,
    pageSize?: number
  ): Observable<PagedResult<DepartmentGroup>> {
    const url = `${this.apiUrl}`;
    let params = new HttpParams();
    if (organizationId) {
      params = params.append('organizationId', organizationId);
    }
    if (query) {
      params = params.append('query', query);
    }
    if (page) {
      params = params.append('page', page);
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize);
    }
    return this.http.get<PagedResult<DepartmentGroup>>(url, {
      params,
    });
  }

  public createDepartmentGroup(request: CreateDepartmentGroupRequest): Observable<number> {
    const url = `${this.apiUrl}`;
    return this.http.post<number>(url, request);
  }

  public updateDepartmentGroup(id: number, request: UpdateDepartmentGroupRequest): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.put<void>(url, request);
  }

  public deleteDepartmentGroup(id: number): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.delete<void>(url);
  }
}
